import { render } from "./saveRole.vue?vue&type=template&id=3163bb32&scoped=true"
import script from "./saveRole.vue?vue&type=script&lang=js"
export * from "./saveRole.vue?vue&type=script&lang=js"

import "./saveRole.vue?vue&type=style&index=0&id=3163bb32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3163bb32"]])

export default __exports__